"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSomeDynamicSchemaValue = void 0;
const DynamicSchemaValue_1 = require("../entity/DynamicSchemaValue");
const dynamicSchemaDefinition_1 = require("./dynamicSchemaDefinition");
const createSomeDynamicSchemaValue = ({ definition = dynamicSchemaDefinition_1.createSomeDynamicSchemaDefinition(), values = {
    cdb_key_41: true,
    cdb_key_1709: 'choice_key_13',
}, } = {}) => DynamicSchemaValue_1.default.fromJSONAndDefinition(values, definition);
exports.createSomeDynamicSchemaValue = createSomeDynamicSchemaValue;
